// extracted by mini-css-extract-plugin
export default {"bar-chart-container":"wMKlk","bar-chart":"hV8Gc"};